// Angular
import {
  Component,
  effect,
  inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgClass } from '@angular/common';
import {
  FormGroup,
  ReactiveFormsModule,
  NonNullableFormBuilder,
  FormControl,
} from '@angular/forms';
// Models
import { RecipientTypeOption } from './models/recipient-type-options.interface';
import { RecipientType } from '../../models/recipient-type.type';
import { ControlsOf } from '@shared/models-v3/controls-of.type';
// PrimeNG
import { RadioButtonModule } from 'primeng/radiobutton';
// Services
import { CheckoutService } from '../../../../services/checkout/checkout.service';
import { formatRecipientTypes } from './services/utils';
import { CheckoutStorageService } from 'src/app/checkout-v2/services/checkout-storage/checkout-storage.service';

const NG_MODULES = [ReactiveFormsModule, NgClass];
const PRIME_MODULES = [RadioButtonModule];

/**
 * Componente para seleccionar la persona que recibe o retira el pedido.
 */
@Component({
  selector: 'app-recipient-type-form',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES],
  templateUrl: './recipient-type-form.component.html',
  host: { class: 'w-full' },
})
export class RecipientTypeFormComponent {
  //#region Outputs
  @Output() onChange: EventEmitter<RecipientType> = new EventEmitter();
  //#endregion

  recipientTypes: RecipientTypeOption[] = [];
  recipientTypeForm!: FormGroup<ControlsOf<{ recipientType: RecipientType }>>;

  //#region Getters
  get recipientTypeField() {
    return this.recipientTypeForm.get('recipientType');
  }
  //#endregion

  //#region Dependencies
  public readonly checkoutService = inject(CheckoutService);
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly checkoutStorageService = inject(CheckoutStorageService);
  //#endregion

  constructor() {
    this.buildForm();
    this.setRecipientTypes();
  }

  /**
   * Establece los tipos de destinatario.
   */
  private setRecipientTypes(): void {
    this.recipientTypes = formatRecipientTypes(
      this.checkoutService.shippingLabel()
    );
    effect(() => {
      this.recipientTypes = formatRecipientTypes(
        this.checkoutService.shippingLabel()
      );
    });
  }

  private buildForm(): void {
    const recipientType = this.checkoutStorageService.getRecipientAnother()
      ? 'ANOTHER'
      : 'SELF';
    this.recipientTypeForm = this.fb.group({
      recipientType: new FormControl<RecipientType>(recipientType, {
        nonNullable: true,
      }),
    });
  }

  /**
   * Al seleccionar un tipo de destinatario.
   * @param recipientType - Tipo de destinatario.
   */
  onSelectRecipientType(recipientType: RecipientType): void {
    this.recipientTypeForm.setValue({ recipientType });
    this.onChange.emit(recipientType);
  }
}
